import { Page } from '~/models/PaginatedItems'
import Product, {
	PRODUCT_CATEGORY,
	PRODUCT_ORDER,
	ProductFilters,
	IndispensableProduct,
} from '~/models/Product'
import { ItineraryService } from '~/passporter-services/itinerary/service'
import { TripProductMetric } from '../metrics/tripProducts'
import { TranslationService } from '~/services/Translation'
import EventsService from '~/services/events'
import { ProductService } from '~/services/product/service'

export class TripProductActions {
	static async getProducts(
		tripId: string,
		order: PRODUCT_ORDER,
		filters: ProductFilters,
		page: number = 0,
		pageSize: number = 12
	): Promise<Page<Product>> {
		try {
			return await ItineraryService.getProducts(tripId, order, page, pageSize, filters)
		} catch (e) {
			console.error(e)
			return { items: [] } as Page<Product>
		}
	}

	static async saveProduct(
		tripId: string,
		product: Product,
		destinationName: string,
		userRole: string,
		routeName: string
	): Promise<void> {
		const translation = TranslationService.getInstance()

		try {
			await ItineraryService.saveProduct(tripId, product.id)
			this.sendAddEvent(tripId, destinationName, product, userRole, routeName)
			const key =
				product.category === PRODUCT_CATEGORY.ACTIVITY
					? 'web.activities.filters.toast.save_success'
					: 'web.store.filters.toast.save_success'
			EventsService.emitSuccess(key)
		} catch (e) {
			const key =
				product.category === PRODUCT_CATEGORY.ACTIVITY
					? 'web.activities.filters.toast.save_error'
					: 'web.store.filters.toast.save_error'
			EventsService.emitError(translation.translate(key))
			console.error(e)
		}
	}

	static async removeProduct(tripId: string, product: Product): Promise<void> {
		const translation = TranslationService.getInstance()

		try {
			await ItineraryService.removeProduct(tripId, product.id)
			const key =
				product.category === PRODUCT_CATEGORY.ACTIVITY
					? 'web.activities.filters.toast.remove_success'
					: 'web.store.filters.toast.remove_success'
			EventsService.emitSuccess(key)
		} catch (e) {
			const key =
				product.category === PRODUCT_CATEGORY.ACTIVITY
					? 'web.activities.filters.toast.remove_error'
					: 'web.store.filters.toast.remove_error'
			EventsService.emitError(translation.translate(key))
			console.error(e)
		}
	}

	static getIndispensables(standardizedCountryName: string): IndispensableProduct[] {
		return ProductService.getIndispensables(standardizedCountryName)
	}

	private static sendAddEvent(
		tripId: string,
		destinationName: string,
		product: Product,
		userRole: string,
		routeName: string
	) {
		TripProductMetric.addFavorite(
			tripId,
			destinationName,
			product.id,
			userRole,
			product.category,
			routeName
		)
	}
}
